import type {
  ApiResponse,
  PageResponse,
  SrmVendorBiddingDetailVo,
  SrmVendorBiddingDraftVo,
  SrmVendorBiddingDto,
  SrmVendorBiddingPageDto,
  SrmVendorBiddingVo,
} from "@/types/apis";
import request from "@/utils/request";

/** 询比价分页查询  */
export const getVendorBiddingPage = (data: SrmVendorBiddingPageDto) =>
  request.post<PageResponse<SrmVendorBiddingVo>>(
    "/purchase/vendor/bidding/pageList",
    data,
  );

/** 询比价详情查询  */
export const getVendorBiddingDetail = (id: number | string) =>
  request.get<ApiResponse<SrmVendorBiddingDetailVo>>(
    `/purchase/vendor/bidding/detail/${id}`,
  );

/** 保存询比价申请 */
export const saveVendorBidding = (data: SrmVendorBiddingDto) =>
  request.post<ApiResponse>("/purchase/vendor/bidding/save", data);

/** 暂存询比价申请 */
export const saveVendorBiddingDraft = (data: Partial<SrmVendorBiddingDto>) =>
  request.post<ApiResponse>("/purchase/vendor/bidding/draft/save", data);

/** 查询暂存的询比价申请 */
export const getVendorBiddingDraftDetail = () =>
  request.get<ApiResponse<SrmVendorBiddingDraftVo>>(
    `/purchase/vendor/bidding/draft/get`,
  );

/** 导出供应商比价表 */
export const exportVendorBiddingPriceCompare = (
  id: string,
  vendorBiddingItemId?: string,
) =>
  request.get<ApiResponse>(`/purchase/vendor/bidding/export/${id}`, {
    responseType: "blob",
    params: {
      vendorBiddingItemId,
    },
  });

/** 保存比较总结 */
export const saveCompareSummary = (data: {
  id: string;
  biddingSummary: string;
}) =>
  request.post<ApiResponse>(
    "/purchase/vendor/bidding/saveBiddingSummary",
    data,
  );

/** 更新样品测试情况和是否符合物料标准  */
export const updateSampleTestAndMaterialStandard = (data: {
  vendorBiddingQuotationId: string;
  sampleTestResult: string;
  complianceWithMaterialStandards: number;
}) =>
  request.post<ApiResponse>(
    "/purchase/vendor/bidding/updateSampleTestAndMaterialStandard",
    data,
  );
